// Whether the admin file row offers its expiry control.
//
// Mirrors the vendor rule in apps/vendor/src/company/Questionnaire.tsx (the
// showExpiryRow computation): never OFFER an expiry date on a question that does
// not collect one, but never orphan a date a file already carries — a stored
// expires_at still drives the expiry-reminder rollup and must stay editable.
//
// Consequence: on a non-expiry question the button can only ever render when a
// date is already set, so its label reads "Edit expiry", never "Add expiry".
export function showExpiryButton({
  expiryEditable,
  requiresExpiry,
  expiresAt,
}: {
  /** False on frozen approved rows, whose files are a historical record. */
  expiryEditable: boolean;
  /** The owning question is flagged requires_expiry. */
  requiresExpiry: boolean;
  /** The date already stored on this file, if any. */
  expiresAt: string | null;
}): boolean {
  if (!expiryEditable) return false;
  return requiresExpiry || expiresAt != null;
}
